var $a103e8224451fef4$exports = {};
const $a103e8224451fef4$var$arBtn = document.getElementById("ar-btn");
const $a103e8224451fef4$var$engBtn = document.getElementById("eng-btn");
// Get stored language preference or default to 'en'
let $a103e8224451fef4$var$currentLang = localStorage.getItem("language") || "en";
// Initialize language on page load
const $a103e8224451fef4$var$initializeLanguage = ()=>{
    $a103e8224451fef4$var$setLanguage($a103e8224451fef4$var$currentLang);
};
// Remove hover effect on active button
const $a103e8224451fef4$var$removeHover = (btn)=>{
    if (btn) btn.classList.add("no-hover");
};
const $a103e8224451fef4$var$addHover = (btn)=>{
    if (btn) btn.classList.remove("no-hover");
};
// Set language function
const $a103e8224451fef4$var$setLanguage = (lang)=>{
    const html = document.documentElement;
    if (lang === "ar") {
        // Set Arabic
        html.setAttribute("lang", "ar");
        html.setAttribute("dir", "rtl");
        html.classList.add("rtl");
        html.classList.remove("ltr");
        // Switch to Arabic display font
        html.style.setProperty("--font-display", "var(--font-display-ar)");
        // Update SIDEBAR button state
        if ($a103e8224451fef4$var$arBtn) {
            $a103e8224451fef4$var$arBtn.classList.add("active");
            $a103e8224451fef4$var$removeHover($a103e8224451fef4$var$arBtn);
        }
        if ($a103e8224451fef4$var$engBtn) {
            $a103e8224451fef4$var$engBtn.classList.remove("active");
            $a103e8224451fef4$var$addHover($a103e8224451fef4$var$engBtn);
        }
        // Update MOBILE MENU button state
        const mobileArBtn = document.querySelector('.mobile-menu-option[data-lang="ar"]');
        const mobileEngBtn = document.querySelector('.mobile-menu-option[data-lang="en"]');
        if (mobileArBtn) mobileArBtn.classList.add("active");
        if (mobileEngBtn) mobileEngBtn.classList.remove("active");
        // Update LANGUAGE PANEL button state
        const panelArBtn = document.querySelector('.language-panel-option[data-lang="ar"]');
        const panelEngBtn = document.querySelector('.language-panel-option[data-lang="en"]');
        if (panelArBtn) panelArBtn.classList.add("active");
        if (panelEngBtn) panelEngBtn.classList.remove("active");
    } else {
        // Set English
        html.setAttribute("lang", "en");
        html.setAttribute("dir", "ltr");
        html.classList.add("ltr");
        html.classList.remove("rtl");
        // Switch to English display font
        html.style.setProperty("--font-display", "var(--font-display-eng)");
        // Update SIDEBAR button state
        if ($a103e8224451fef4$var$engBtn) {
            $a103e8224451fef4$var$engBtn.classList.add("active");
            $a103e8224451fef4$var$removeHover($a103e8224451fef4$var$engBtn);
        }
        if ($a103e8224451fef4$var$arBtn) {
            $a103e8224451fef4$var$arBtn.classList.remove("active");
            $a103e8224451fef4$var$addHover($a103e8224451fef4$var$arBtn);
        }
        // Update MOBILE MENU button state
        const mobileArBtn = document.querySelector('.mobile-menu-option[data-lang="ar"]');
        const mobileEngBtn = document.querySelector('.mobile-menu-option[data-lang="en"]');
        if (mobileEngBtn) mobileEngBtn.classList.add("active");
        if (mobileArBtn) mobileArBtn.classList.remove("active");
        // Update LANGUAGE PANEL button state
        const panelArBtn = document.querySelector('.language-panel-option[data-lang="ar"]');
        const panelEngBtn = document.querySelector('.language-panel-option[data-lang="en"]');
        if (panelEngBtn) panelEngBtn.classList.add("active");
        if (panelArBtn) panelArBtn.classList.remove("active");
    }
    // Save preference to localStorage
    localStorage.setItem("language", lang);
    $a103e8224451fef4$var$currentLang = lang;
    // Trigger changing language event
    window.dispatchEvent(new CustomEvent("languageChanged", {
        detail: {
            lang: lang
        }
    }));
};
// Sidebar button listeners
if ($a103e8224451fef4$var$arBtn) $a103e8224451fef4$var$arBtn.addEventListener("click", ()=>{
    $a103e8224451fef4$var$setLanguage("ar");
});
if ($a103e8224451fef4$var$engBtn) $a103e8224451fef4$var$engBtn.addEventListener("click", ()=>{
    $a103e8224451fef4$var$setLanguage("en");
});
// Initialize on page load
document.addEventListener("DOMContentLoaded", ()=>{
    $a103e8224451fef4$var$initializeLanguage();
});
const $a103e8224451fef4$var$getCurrentLanguage = ()=>{
    return $a103e8224451fef4$var$currentLang;
};
// Make setLanguage available globally
window.setLanguage = $a103e8224451fef4$var$setLanguage;


//# sourceMappingURL=repo.5706ce63.js.map
